import styled from 'styled-components'

export const ImageItemSoftwares = styled.div`
    height: calc(100% - 70px);
    background-image: ${props => `url(${props.background})`};
    background-position: center;
    background-size: cover;

`
